<template>
    <div class="loginku">
        <div class="form_login">
            <div class="row" style="padding: 2%">

                <div class="col-md-4 offset-md-4">
                    <div class="transparant1 container">
                        <br>
                        <img src="assets/img/silada.png" alt="" width="100%" height="110%">
                        <br>

                        <div v-if="LoggingIn" class="text-center">
                            <img src="img/Packman.svg" alt="">
                        </div>
                        <br>
                        <div v-if="errorMessage" class="alert alert-warning">
                            <strong>Warning!</strong> {{ errorMessage }}.
                        </div>

                        <form v-if="!LoggingIn" @submit.prevent="btn_login()">
                            <div class="form-group">
                                <label for="email2">Username</label>
                                <input  v-model="user.username" type="text" class="form-control" placeholder="Enter Email">
                                
                            </div>

                            <div class="form-group">
                                <label for="email2">Password</label>
                                <input v-model="user.password" type="password" class="form-control" placeholder="Enter Password">
                                
                            </div>

                            <br>
                            <button type="submit" class="btn btn-info btn-block">
                                <b>LOGIN</b>
                            </button>

                        </form>


                        <hr><br>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>


<script>

// const ADD_URL = URL_APP + "api/v1/rincian_obyek/";

  import Joi from "joi";
  const LOGIN_URL =  URL_APP + "auth/login";

  const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
    password: Joi.string().min(6).required(),
  });

  export default {
    name: "monev_login",
    data : function(){
      return {
          LoggingIn: false,
          errorMessage: '',
          user : {
            username : "",
            password : ""
          }
      }
    },
    watch: {
      user: {
          handler() {
              this.errorMessage = "";
          },
          deep: true
      }
    },
    methods: {
      // go_register : function(){
      //   alert(App.data().sesseee);
      //   this.displayed = 'block';
      // },
      btn_login : function(){
        this.errorMessage = '';
        if(this.validUser()){
          this.LoggingIn = true;
          const body = {
            username : this.user.username,
            password : this.user.password
          }
          fetch(LOGIN_URL, {
            method : 'POST',
            headers : {
              'content-type' : 'application/json',
            },
            body : JSON.stringify(body),
          }).then((response) => {
            
            console.log(response);
            
                if (response.ok) {
                    return response.json();
                }

                return response.json().then(error => {
                    throw new Error(error.message);
                });
            })
            .then((result) => {
              console.log("=============================");
              console.log(result);
              // menyimpan token yang tergenerate dari server
              localStorage.token = result.token;
              localStorage.profile = JSON.stringify(result.profile);
              setTimeout(() => {
                this.LoggingIn = false;
                this.$router.push('/');
                location.reload();
              }, 1000);
            })
            .catch(error => {
              setTimeout(() => {
                this.LoggingIn = false;
                this.errorMessage = error.message;
              }, 1000);
            });;
        }



      },
      validUser: function(){
        const result = Joi.validate(this.user, schema);
        if (result.error === null) {
          return true;
        }
        if (result.error.message.includes("username")) {
          this.errorMessage = "Username tidak valid";
        } else {
          this.errorMessage = "Username tidak valid2";
        }
        return false;
      },
    },
    mounted : function(){


      

    },
  };
</script>

<style>

</style>
